import { EMPTY_RESULTS } from './constants'
import { searchPgaCoachOfferings } from './offering-search'
import { pathToJourneySearchState } from './search-state'

export async function getPgaCoachJourneySearchInitialProps({ asPath, query }) {
  const searchState = await pathToJourneySearchState(asPath, query?.param)
  try {
    const initialResults = await searchPgaCoachOfferings(searchState)
    return {
      initialSearchState: searchState,
      initialResults,
      query,
    }
  } catch (error) {
    return {
      initialSearchState: searchState,
      initialResults: {
        ...EMPTY_RESULTS,
      },
      initialError: error.message,
      query,
    }
  }
}
